<template>
  <div class="store-detail-page">
    <el-tabs v-model="activeTab" class="detail-tabs" @tab-change="onTabChange">
      <el-tab-pane label="概览" name="overview">
        <store-overview-tab
          :brand-info="brandInfo"
          :store-info="storeInfo"
          :brand-company-info="brandCompanyInfo"
          :store-company-info="storeCompanyInfo"
          :can-edit="hasPermission('store:edit')"
          @edit="editDialogVisible = true"
        />
      </el-tab-pane>

      <el-tab-pane label="营收趋势" name="revenue" lazy>

    <el-card class="detail-card" shadow="hover">
      <div class="card-header">
        <h2>门店收入情况趋势图</h2>
        <div class="date-range-picker">
          <el-date-picker
              v-model="dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="handleDateRangeChange"
              value-format="YYYY-MM-DD"
          ></el-date-picker>
          <el-radio-group v-model="viewMode" @change="handleViewModeChange" style="margin-left: 10px;">
            <el-radio-button label="day">按日</el-radio-button>
            <el-radio-button label="month">按月</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="income-chart-container">
        <div ref="incomeChart" class="income-chart"></div>
      </div>
    </el-card>
      </el-tab-pane>

      <el-tab-pane label="协议与出资" name="agreement" lazy>
        <store-agreement-tab
          :agreement-list="agreementList"
          :fund-list="fundList"
          :profit-distribution-list="profitDistributionList"
          @create-agreement="handleCreateAgreement"
          @create-fund="handleCreateFundInfo"
          @create-profit="handleCreateProfitDistribution"
          @view-receipt="handleViewReceipt"
        />
      </el-tab-pane>

      <el-tab-pane label="基础资料" name="document" lazy>
        <store-document-tab
          :document-types="documentTypes"
          :document-files="documentFiles"
          @view-document="handleViewDocument"
        />
      </el-tab-pane>
    </el-tabs>

    <store-document-dialog
      v-model="docDialogVisible"
      :doc="currentDoc"
      :store-ent-code="storeInfo.storeEntCode || storeEntCode"
      :upload-url="uploadUrl"
      :upload-headers="uploadHeaders"
      v-model:file-list="fileList"
      :before-upload="beforeUpload"
      @download="handleDownloadFile"
      @delete-file="handleDeleteFile"
      @upload-success="handleUploadSuccess"
      @upload-error="handleUploadError"
    />
    <el-dialog
        title="新增联营协议"
        v-model="createAgreementVisible"
        width="600px"
    >
      <el-form :model="agreementForm" ref="agreementFormRef" label-width="120px">
        <el-form-item label="协议编号" prop="agreementNo" required>
          <el-input v-model="agreementForm.agreementNo"></el-input>
        </el-form-item>
        <el-form-item label="品牌编码" prop="brandCode" required>
          <el-input v-model="agreementForm.brandCode" disabled></el-input>
        </el-form-item>
        <el-form-item label="开始时间" prop="jointStartTime" required>
          <el-date-picker v-model="agreementForm.jointStartTime" type="date" value-format="YYYY-MM-DD"></el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="jointEndTime" required>
          <el-date-picker v-model="agreementForm.jointEndTime" type="date" value-format="YYYY-MM-DD"></el-date-picker>
        </el-form-item>
        <el-form-item label="初始分成比例(%)" prop="initialShareRatio">
          <el-input v-model.number="agreementForm.initialShareRatio" type="number"></el-input>
        </el-form-item>
        <el-form-item label="联营类型" prop="jointOperationType" required>
          <el-select v-model="agreementForm.jointOperationType">
            <el-option label="固定本息" value="1"></el-option>
            <el-option label="固定收益" value="2"></el-option>
            <el-option label="固定时长" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="agreementForm.jointOperationType==='1'" label="预估回收总金额(元)" prop="totalShareAmount" required>
          <el-input v-model.number="agreementForm.totalShareAmount" type="number"></el-input>
        </el-form-item>
        <el-form-item v-if="agreementForm.jointOperationType==='1'" label="每天还款金额(元)" prop="dailyRepaymentAmount" required>
          <el-input v-model.number="agreementForm.dailyRepaymentAmount" type="number"></el-input>
        </el-form-item>
        <el-form-item v-if="agreementForm.jointOperationType==='2'" label="固定月息(%)" prop="fixedMonthlyRate" required>
          <el-input v-model.number="agreementForm.fixedMonthlyRate" type="number"></el-input>
        </el-form-item>
        <el-form-item label="投资金额(元)" prop="investAmount" required>
          <el-input v-model.number="agreementForm.investAmount" type="number"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="createAgreementVisible=false">取消</el-button>
        <el-button type="primary" @click="submitCreateAgreement">提交</el-button>
      </template>
    </el-dialog>

    <el-dialog
        title="新增出资信息"
        v-model="createFundVisible"
        width="600px"
    >
      <el-form :model="fundForm" :rules="fundFormRules" ref="fundFormRef" label-width="120px">
        <el-form-item label="协议编号" prop="agreementNo" required>
          <el-select v-model="fundForm.agreementNo" placeholder="请选择协议">
            <el-option v-for="a in fundCandidates" :key="a.agreementNo" :label="a.agreementNo" :value="a.agreementNo" />
          </el-select>
        </el-form-item>
        <el-form-item label="出资方" prop="tenantId" required>
          <el-select v-model="fundForm.tenantId" placeholder="请选择系统租户">
            <el-option v-for="t in tenants" :key="t.id" :label="t.tenantName" :value="String(t.id)" />
          </el-select>
        </el-form-item>
        <el-form-item label="出资金额(元)" prop="fundAmount" required>
          <el-input v-model.number="fundForm.fundAmount" type="number"></el-input>
        </el-form-item>
        <el-form-item label="出资比例(%)" prop="fundRatio" required>
          <el-input v-model.number="fundForm.fundRatio" type="number"></el-input>
        </el-form-item>
        <el-form-item label="出资时间" prop="fundTime" required>
          <el-date-picker v-model="fundForm.fundTime" type="date" value-format="YYYY-MM-DD"></el-date-picker>
        </el-form-item>
        <el-form-item label="出资账户" prop="fundAccount" required>
          <el-input v-model="fundForm.fundAccount"></el-input>
        </el-form-item>
        <el-form-item label="到账账户" prop="receiptAccount" required>
          <el-input v-model="fundForm.receiptAccount"></el-input>
        </el-form-item>
        <el-form-item label="银行回单">
          <span>选填，提交后可在出资信息表中查看</span>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="createFundVisible=false">取消</el-button>
        <el-button type="primary" @click="submitCreateFund">提交</el-button>
      </template>
    </el-dialog>

    <el-dialog
        title="新增收益分配信息"
        v-model="createProfitVisible"
        width="600px"
    >
      <el-form :model="profitForm" :rules="profitFormRules" ref="profitFormRef" label-width="120px">
        <el-form-item label="协议编号" prop="agreementNo" required>
          <el-select v-model="profitForm.agreementNo" placeholder="请选择协议" @change="onProfitAgreementChange">
            <el-option v-for="a in uniqueProfitAgreements" :key="a.agreementNo" :label="a.agreementNo" :value="a.agreementNo" />
          </el-select>
        </el-form-item>
        <el-form-item label="收益分配对象" prop="tenant" required>
          <el-select v-model="profitForm.tenant" placeholder="请选择出资方" @change="onProfitTenantChange">
            <el-option v-for="t in profitTenantOptions" :key="t.value" :label="t.label" :value="t.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="出资流水号" prop="fundSerialId">
          <el-input v-model="profitForm.fundSerialId" readonly placeholder="自动匹配"></el-input>
        </el-form-item>
        <el-form-item label="收益方案" prop="profitSharingPlan" required>
          <el-select v-model="profitForm.profitSharingPlan" placeholder="请选择收益方案">
            <el-option v-for="p in allowedProfitPlans" :key="p" :label="p" :value="p" />
          </el-select>
        </el-form-item>
        <el-form-item label="保底收益(%)" prop="seniorFloorFloorIncome" required>
          <el-input v-model.number="profitForm.seniorFloorFloorIncome" type="number"></el-input>
        </el-form-item>
        <el-form-item label="额外收益分成(%)" prop="additionalProfitShareRatio" required>
          <el-input v-model.number="profitForm.additionalProfitShareRatio" type="number"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="createProfitVisible=false">取消</el-button>
        <el-button type="primary" @click="submitCreateProfit">提交</el-button>
      </template>
    </el-dialog>

    <!-- 门店信息编辑对话框 -->
    <store-edit-dialog
      v-model="editDialogVisible"
      :store-info="storeInfo"
      :store-ent-code="storeEntCode"
      @saved="getStoreInfo"
    />
  </div>
</template>

<script>
import {onMounted, reactive, toRefs, ref, nextTick, computed} from 'vue'
import { useRoute } from 'vue-router'
import * as echarts from 'echarts'
import {ElLink, ElMessage, ElTag, ElButton, ElDialog, ElForm, ElFormItem, ElInput, ElSelect, ElOption, ElDatePicker, ElRow, ElCol,ElUpload} from 'element-plus'
import assetService from '@/services/assetService'
import tenantService from '@/services/tenantService'
import store from "@/store"
import { formatDate } from '@/utils/dateUtils';
import StoreOverviewTab from './store/StoreOverviewTab.vue'
import StoreAgreementTab from './store/StoreAgreementTab.vue'
import StoreDocumentTab from './store/StoreDocumentTab.vue'
import StoreEditDialog from './store/StoreEditDialog.vue'
import StoreDocumentDialog from './store/StoreDocumentDialog.vue'



// 后端部分接口返回数组，统一取首元素；
// 否则把数组赋给对象字段，模板取值全为 undefined，页面看起来就是「空的」
const pickObject = (data) => {
  if (Array.isArray(data)) return data[0] || {}
  return data || {}
}

// 格式化金额
const formatCurrency = (value) => {
  if (!value) return '0.00'
  return Number(value).toLocaleString('zh-CN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
}

// 格式化联营类型
const formatJointType = (type) => {
  const typeMap = {
    '1': '固定本息',
    '2': '固定收益',
    '3': '固定时长'
  }
  return typeMap[type] || type
}

// 格式化状态
const formatStatus = (status) => {
  const statusMap = {
    '1': '联营中',
    '2': '正常联营结束',
    '3': '投后风险处理中',
    '4': '提前回购'
  }
  return statusMap[status] || status
}

// 获取状态标签类型
const getStatusTagType = (status) => {
  const typeMap = {
    '1': 'success',
    '2': 'info',
    '3': 'warning'
  }
  return typeMap[status] || 'default'
}

// 格式化注册资本
const formatCapital = (companyInfo) => {
  if (!companyInfo) return '-'
  const { registered_capital, registered_capital_unit, registered_capital_ccy } = companyInfo
  if (!registered_capital) return '-'

  let capitalStr = registered_capital
  if (registered_capital_unit) capitalStr += registered_capital_unit
  if (registered_capital_ccy && registered_capital_ccy !== 'CNY') capitalStr += `(${registered_capital_ccy})`

  return capitalStr
}

// 计算默认日期范围（近30天）
const getDefaultDateRange = () => {
  const end = new Date()
  const start = new Date()
  start.setTime(start.getTime() - 30 * 24 * 60 * 60 * 1000)
  return [
    start.toISOString().split('T')[0],
    end.toISOString().split('T')[0]
  ]
}

export default {
  name: 'StoreDetail',
  components: {
    ElLink,
    ElTag,
    ElButton,
    ElDialog,
    ElForm,
    ElFormItem,
    ElInput,
    ElSelect,
    ElOption,
    ElDatePicker,
    ElRow,
    ElCol,
    ElUpload,
    StoreOverviewTab,
    StoreAgreementTab,
    StoreDocumentTab,
    StoreEditDialog,
    StoreDocumentDialog
  },
  setup() {
    const route = useRoute()
    const storeEntCode = route.params.storeEntCode

    // 当前激活的分区
    const activeTab = ref('overview')

    // 新增：文件上传相关
    const uploadRef = ref(null)
    const fileList = ref([])

    // 图表实例
    const incomeChart = ref(null)
    const chartInstance = ref(null)

    // 编辑表单引用
    const fundFormRef = ref(null)
    const profitFormRef = ref(null)

    const state = reactive({
      // 折叠面板状态
      brandCollapse: [],
      storeCollapse: [],

      // 日期范围选择，默认近30天
      dateRange: getDefaultDateRange(),
      // 时间粒度选择：day-按日显示，month-按月显示
      viewMode: 'day',

      // 数据
      brandInfo: {},
      storeInfo: {},
      brandCompanyInfo: {},
      storeCompanyInfo: {},
      agreementList: [],
      incomeData: [],
      fundList:[],
      profitDistributionList: [],

      // 编辑相关
      editDialogVisible: false,
      hasEditPermission: false, // 是否有编辑权限

      // 表单验证规则

      // 加载状态
      loading: {
        brand: false,
        store: false,
        agreements: false,
        income: false,
        fund: false,
        profitDistribution: false,
      },

      // 修改文档相关状态以支持多文件
      documentTypes: [
        { type: 'businessLicense', name: '营业执照' },
        { type: 'legalId', name: '法人身份证' },
        { type: 'controllerId', name: '实控人身份证' },
        { type: 'leaseContract', name: '租约' },
        { type: 'financialReport', name: '财务报表' },
        { type: 'creditReport', name: '征信报告' },
        { type: 'signedAgreement', name: '已签署协议' },
        { type: 'other', name: '其他材料' }
      ],
      documentFiles: {}, // 存储各类型文件列表 { type: [{id, url, fileName, uploadTime}, ...] }
      docDialogVisible: false,
      currentDoc: { type: '', name: '', files: [] },
      uploadUrl: '/dm/store/upload/document', // 需后端支持多文件上传
      createAgreementVisible: false,
      createFundVisible: false,
      createProfitVisible: false,
      agreementForm: {},
      fundForm: {},
      fundFormRules: {},
      profitForm: {},
      fundCandidates: [],
      profitCandidates: [],
      tenants: [],
      profitFormRules: {},
      profitTenantOptions: [],
      allowedProfitPlans: [],
      currentAgreementFunds: [],
    })

    // 获取品牌信息
    const getBrandInfo = async (brandCode) => {
      if (!brandCode) return

      try {
        state.loading.brand = true
        const params = {
          brandCode: brandCode
        }
        const response = await assetService.getBrandBaseInfo(params)
        state.brandInfo = pickObject(response?.data)

        // 获取品牌工商信息
        if (state.brandInfo.brandBusinessLicense) {
          const companyRes = await assetService.getCompanyBaseInfo({business_license : state.brandInfo.brandBusinessLicense})
          state.brandCompanyInfo = pickObject(companyRes?.data)
        }
      } catch (error) {
        ElMessage.error('获取品牌信息失败：' + (error.message || ''))
      } finally {
        state.loading.brand = false
      }
    }

    // 获取门店信息
    const getStoreInfo = async () => {
      try {
        state.loading.store = true
        const params = {
          storeEntCode: storeEntCode
        }
        const response = await assetService.getStoreDetail(params)

        // 修正：接口可能返回数组，统一取第一个元素作为门店信息对象
        state.storeInfo = pickObject(response?.data)

        // 获取门店工商信息（修正字段名）
        if (state.storeInfo.storeBusinessLicense) {
          const companyRes = await assetService.getCompanyBaseInfo({
            business_license: state.storeInfo.storeBusinessLicense
          })
          state.storeCompanyInfo = pickObject(companyRes?.data)
        }

        // 获取品牌信息（修正字段名）
        if (state.storeInfo.brandCode) {
          getBrandInfo(state.storeInfo.brandCode)
        }

        const agreement_param = {
          storeEntCode: storeEntCode,
          tenantId: store.state.tenantId
        }

        // 获取联营协议
        await getAgreementList(agreement_param)

        // 获取收入数据
        await getIncomeData(storeEntCode)

        // 检查编辑权限
        state.hasEditPermission = hasPermission('store:edit')

        // 获取门店文件资料
        await getStoreDocuments()

      } catch (error) {
        ElMessage.error('获取门店信息失败：' + (error.message || ''))
      } finally {
        state.loading.store = false
      }
    }

    // 获取联营协议列表
    const getAgreementList = async (params) => {
      try {
        state.loading.agreements = true
        const response = await assetService.getAgreementListByStoreEntCode(params)
        state.agreementList = response.data || []

        // 新增：获取所有协议的出资信息
        await getFundList({store_ent_code: storeEntCode })

        // 新增：获取投资人收益分配方案
        await getProfitDistributionList({store_ent_code: storeEntCode})

      } catch (error) {
        ElMessage.error('获取联营协议失败：' + (error.message || ''))
      } finally {
        state.loading.agreements = false
      }
    }

    // 获取用户权限集合（仅包含权限编码）
    const permissionCodes = computed(() => {
      const permissions = store.state.permissions
      if (!permissions) return []
      // 将权限对象转换为权限编码数组
      return Object.values(permissions).map(perm => perm.permissionCode)
    })

    // 权限判断方法
    const hasPermission = (code) => {
      return permissionCodes.value.includes(code)
    }

    // 获取出资信息列表
    const getFundList = async (params) => {
      try {
        state.loading.funds = true
        const response = await assetService.getJointOperationFunds(params)
        state.fundList = response.data || []
      } catch (error) {
        ElMessage.error('获取出资信息失败：' + (error.message || ''))
      } finally {
        state.loading.funds = false
      }
    }

    // 新增：获取收益分配信息列表
    const getProfitDistributionList = async (params) => {
      try {
        state.loading.profitDistribution = true
        const response = await assetService.getJointOperationProfitDistribution(params)
        state.profitDistributionList = response.data || []
      } catch (error) {
        ElMessage.error('获取收益分配信息失败：' + (error.message || ''))
      } finally {
        state.loading.profitDistribution = false
      }
    }

    // 查看银行回单
    const handleViewReceipt = (url) => {
      // 可以打开新窗口显示回单图片或文件
      window.open(url, '_blank')
    }

    const handleCreateAgreement = async () => {
      try {
        const res = await assetService.checkStoreDocumentsComplete({ storeEntCode });
        const data = res.data || {};
        console.log(data)
        if (!data.complete) {
          const names = state.documentTypes.filter(d => (data.missingTypes || []).includes(d.type)).map(d => d.name).join('、');
          ElMessage.error(`资料未齐全，缺少：${names}`);
          return;
        }
        state.agreementForm = {
          agreementNo: '',
          brandCode: state.brandInfo.brandCode || '',
          jointStartTime: '',
          jointEndTime: '',
          initialShareRatio: 0,
          jointOperationType: '1',
          totalShareAmount: 0,
          dailyRepaymentAmount: 0,
          fixedMonthlyRate: 0,
          investAmount: 0,
          storeEntCode: state.storeInfo.storeEntCode || ''
        };
        state.createAgreementVisible = true;
      } catch (e) {
        ElMessage.error('校验失败：' + (e.message || ''))
      }
    }

    const handleCreateFundInfo = async () => {
      try {
        const res = await assetService.checkAgreementMissingInfo({ storeEntCode });
        const info = res.data || {};
        const agreements = info.agreements || [];
        state.fundCandidates = agreements.filter(a => a.missingFund);
        if (state.fundCandidates.length === 0) {
          ElMessage.error('所有协议的总出资比例均已达到100%，不允许新增');
          return;
        }
        const tenantsRes = await tenantService.getTenantList({ pageNum: 1, pageSize: 1000, keyword: '' })
        state.tenants = tenantsRes.data || []
        state.fundForm = {
          agreementNo: '',
          tenantId: '',
          fundAmount: 0,
          fundRatio: 0,
          fundTime: '',
          fundAccount: '',
          receiptAccount: ''
        };
        state.fundFormRules = {
          agreementNo: [ { required: true, message: '请选择协议', trigger: 'change' } ],
          tenantId: [ { required: true, message: '请选择出资方', trigger: 'change' } ],
          fundAmount: [ { required: true, message: '请输入出资金额', trigger: 'blur' } ],
          fundRatio: [ { required: true, message: '请输入出资比例', trigger: 'blur' } ],
          fundTime: [ { required: true, message: '请选择出资时间', trigger: 'change' } ],
          fundAccount: [ { required: true, message: '请输入出资账户', trigger: 'blur' } ],
          receiptAccount: [ { required: true, message: '请输入到账账户', trigger: 'blur' } ],
        }
        state.createFundVisible = true;
      } catch (e) {
        ElMessage.error('校验失败：' + (e.message || ''))
      }
    }

    const handleCreateProfitDistribution = async () => {
      try {
        const res = await assetService.checkAgreementMissingInfo({ storeEntCode });
        const info = res.data || {};
        const agreements = info.agreements || [];
        
        const funds = state.fundList || [];
        const profitDistributions = state.profitDistributionList || [];
        
        const missingDistributionFunds = [];
        
        for (const fund of funds) {
          const hasDistribution = profitDistributions.some(pd => 
            pd.agreementNo === fund.agreementNo && 
            pd.fundSerialId === fund.id
          );
          
          if (!hasDistribution) {
            const agreement = agreements.find(a => a.agreementNo === fund.agreementNo);
            if (agreement) {
              missingDistributionFunds.push({
                agreementNo: fund.agreementNo,
                tenantId: fund.tenantId,
                tenantName: fund.tenantName,
                fundId: fund.id,
                fundSerialId: fund.id
              });
            }
          }
        }
        
        if (missingDistributionFunds.length === 0) {
          ElMessage.warning('所有协议的出资方均已配置收益分配信息，不允许新增');
          return;
        }
        
        state.profitCandidates = missingDistributionFunds;
        
        state.profitForm = {
          agreementNo: '',
          profitSharingPlan: '',
          seniorFloorFloorIncome: 0,
          additionalProfitShareRatio: 0
        };
        state.profitFormRules = {
          agreementNo: [ { required: true, message: '请选择协议', trigger: 'change' } ],
          tenant: [ { required: true, message: '请选择收益分配对象', trigger: 'change' } ],
          profitSharingPlan: [ { required: true, message: '请选择收益方案', trigger: 'change' } ],
          seniorFloorFloorIncome: [ { required: true, message: '请输入保底收益', trigger: 'blur' } ],
          additionalProfitShareRatio: [ { required: true, message: '请输入额外收益分成比例', trigger: 'blur' } ],
        }
        state.profitTenantOptions = []
        state.allowedProfitPlans = []
        state.createProfitVisible = true;
      } catch (e) {
        ElMessage.error('校验失败：' + (e.message || ''))
      }
    }

    const submitCreateAgreement = async () => {
      try {
        const payload = { ...state.agreementForm };
        payload.initialShareRatio = Number(payload.initialShareRatio || 0) / 100;
        if (payload.jointOperationType === '1') {
          if (!payload.totalShareAmount || !payload.dailyRepaymentAmount) {
            ElMessage.error('固定本息需填写预估回收总金额与每天还款金额');
            return;
          }
        } else if (payload.jointOperationType === '2') {
          if (!payload.fixedMonthlyRate) {
            ElMessage.error('固定收益需填写固定月息');
            return;
          }
        }
        await assetService.createAgreement(payload);
        ElMessage.success('新增联营协议成功');
        state.createAgreementVisible = false;
        await getAgreementList();
      } catch (e) {
        ElMessage.error('提交失败：' + (e.message || ''))
      }
    }

    const submitCreateFund = async () => {
      try {
        if (fundFormRef.value) {
          await fundFormRef.value.validate()
        }
        const payload = { ...state.fundForm };
        payload.fundRatio = Number(payload.fundRatio || 0) / 100;
        await assetService.createJointOperationFund(payload);
        ElMessage.success('新增出资信息成功');
        state.createFundVisible = false;
        await getFundList({store_ent_code: storeEntCode});
      } catch (e) {
        ElMessage.error('提交失败：' + (e.message || ''))
      }
    }

    const submitCreateProfit = async () => {
      try {
        if (profitFormRef.value) {
          await profitFormRef.value.validate()
        }
        const payload = { ...state.profitForm };
        payload.seniorFloorFloorIncome = Number(payload.seniorFloorFloorIncome || 0) / 100;
        payload.additionalProfitShareRatio = Number(payload.additionalProfitShareRatio || 0) / 100;
        await assetService.createJointOperationProfitDistribution(payload);
        ElMessage.success('新增收益分配信息成功');
        state.createProfitVisible = false;
        await getProfitDistributionList({store_ent_code: storeEntCode});
      } catch (e) {
        ElMessage.error('提交失败：' + (e.message || ''))
      }
    }

    const onProfitAgreementChange = async (agreementNo) => {
      try {
        if (!agreementNo) return
        state.profitForm.tenant = ''
        state.profitForm.fundSerialId = ''
        state.profitForm.profitSharingPlan = ''

        const missingFunds = state.profitCandidates.filter(pc => pc.agreementNo === agreementNo)
        const tenantMap = {}
        state.currentAgreementFunds = missingFunds
        state.profitTenantOptions = missingFunds
          .filter(f => f && f.tenantId != null)
          .map(f => {
            const label = f.tenantName || String(f.tenantId)
            const value = String(f.tenantId)
            if (!tenantMap[value]) {
              tenantMap[value] = true
              return { label, value }
            }
            return null
          })
          .filter(Boolean)

        const profitRes = await assetService.getJointOperationProfitDistribution({ store_ent_code: storeEntCode })
        const allProfit = (profitRes.data || []).filter(p => p && p.agreementNo === agreementNo)
        if (allProfit.length === 0) {
          state.allowedProfitPlans = ['平层', '劣后层']
        } else {
          const hasPingCeng = allProfit.some(p => p.profitSharingPlan === '平层')
          const hasLieHouCeng = allProfit.some(p => p.profitSharingPlan === '劣后层')
          if (hasPingCeng) {
            state.allowedProfitPlans = ['平层']
          } else if (hasLieHouCeng) {
            state.allowedProfitPlans = ['优先层', '劣后层']
          } else {
            state.allowedProfitPlans = []
          }
        }
      } catch (e) {
        ElMessage.error('加载协议相关信息失败：' + (e.message || ''))
      }
    }

    const onProfitTenantChange = (tenantId) => {
      if (!tenantId) {
        state.profitForm.fundSerialId = ''
        return
      }
      const matched = (state.currentAgreementFunds || []).filter(f => f.tenantId === tenantId)
      state.profitForm.fundSerialId = matched.length > 0 ? matched[0].fundId : ''
    }

    // 获取收入数据
    const getIncomeData = async (storeEntCode) => {
      if (!state.dateRange || state.dateRange.length < 2) return

      try {
        state.loading.income = true
        const [startDate, endDate] = state.dateRange
        const response = await assetService.getStoreIncome({
          storeEntCode: storeEntCode,
          start_date: startDate,  // 传递开始时间
          end_date: endDate       // 传递结束时间
        })
        
        // 根据viewMode处理数据
        let processedData = response.data
        if (state.viewMode === 'month') {
          // 按月聚合数据
          const monthlyData = {}
          processedData.forEach(item => {
            if (!item.incomeDate) return
            
            // 提取年月（YYYY-MM）
            const yearMonth = item.incomeDate.substring(0, 7)
            
            if (!monthlyData[yearMonth]) {
              monthlyData[yearMonth] = {
                incomeDate: yearMonth,
                turnover: 0,
                actualAmount: 0
              }
            }
            
            // 累加营业额和实收金额
            monthlyData[yearMonth].turnover += item.turnover || 0
            monthlyData[yearMonth].actualAmount += item.actualAmount || 0
          })
          
          // 转换为数组并按月份排序
          processedData = Object.values(monthlyData).sort((a, b) => a.incomeDate.localeCompare(b.incomeDate))
        }
        
        state.incomeData = processedData
        initIncomeChart()
      } catch (error) {
        ElMessage.error('获取收入数据失败：' + (error.message || ''))
      } finally {
        state.loading.income = false
      }
    }

    // 初始化收入趋势图
    const initIncomeChart = () => {
      if (!incomeChart.value) return

      // 销毁已有图表
      if (chartInstance.value) {
        chartInstance.value.dispose()
      }

      // 创建新图表
      chartInstance.value = echarts.init(incomeChart.value)

      // 准备图表数据
      // 根据viewMode选择不同的日期格式
      const dateFormat = state.viewMode === 'day' ? 'YYYY-MM-DD' : 'YYYY-MM'
      const xAxisData = state.incomeData.map(item => formatDate(item.incomeDate, dateFormat))
      const turnoverData = state.incomeData.map(item => item.turnover || 0)
      const actualAmountData = state.incomeData.map(item => item.actualAmount || 0)

      // 配置图表
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: ['营业额', '实收金额'],
          top: 0
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: xAxisData,
          axisLabel: {
            rotate: 45,
            interval: 0
          }
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value} 元'
          }
        },
        series: [
          {
            name: '营业额',
            type: 'bar',
            data: turnoverData,
            itemStyle: {
              color: '#409eff'
            }
          },
          {
            name: '实收金额',
            type: 'line',
            data: actualAmountData,
            itemStyle: {
              color: '#f56c6c'
            },
            lineStyle: {
              color: '#f56c6c'
            }
          }
        ]
      }

      // 设置图表配置
      chartInstance.value.setOption(option)

      // 监听窗口大小变化，重绘图表
      window.addEventListener('resize', () => {
        if (chartInstance.value) {
          chartInstance.value.resize()
        }
      })
    }

    // 日期范围变更处理
    const handleDateRangeChange = () => {
      if (storeEntCode) {
        getIncomeData(storeEntCode)
      }
    }

    // 时间粒度模式切换处理
    const handleViewModeChange = () => {
      if (storeEntCode) {
        getIncomeData(storeEntCode)
      }
    }

    // 页面挂载时获取数据
    onMounted(() => {
      if (storeEntCode) {
        getStoreInfo()
      } else {
        ElMessage.error('门店编码不存在')
      }
    })

    // 打开编辑对话框

    // 关闭编辑对话框

    // 提交编辑表单

    // 新增：获取门店文件资料
    const getStoreDocuments = async () => {
      try {
        const response = await assetService.getStoreDocuments({
          storeEntCode: storeEntCode
        });
        const backendData = response.data || {};
        console.log('backendData', backendData)
        // 转换后端数据结构：将每个类型的文件列表映射为前端需要的格式
        const formattedFiles = {};
        Object.keys(backendData).forEach(type => {
          // 后端返回的是List<StoreDocument>，需要转换为前端表格需要的结构
          formattedFiles[type] = backendData[type].map(doc => ({
            id: doc.id, // 文件ID（用于删除）
            url: doc.fileUrl, // 文件URL（用于下载）
            fileName: doc.fileName || '未命名文件', // 文件名
            uploadTime: doc.uploadTime // 上传时间（用于格式化显示）
          }));
        });
        state.documentFiles = formattedFiles; // 存储转换后的数据
      } catch (error) {
        ElMessage.error('获取门店资料失败：' + (error.message || ''));
      }
    }

    // 新增：查看文件
    const handleViewDocument = (doc) => {
      state.currentDoc = {
        ...doc,
        files: state.documentFiles[doc.type] || []
      }
      state.docDialogVisible = true
      fileList.value = [] // 清空文件列表
    }

    // 新增：关闭文件对话框
    const handleCloseDocDialog = () => {
      state.docDialogVisible = false
      fileList.value = []
    }

    // 新增：判断是否为图片
    const isImage = (url) => {
      const imgExts = ['.jpg', '.jpeg', '.png', '.gif', '.bmp']
      const ext = url.substring(url.lastIndexOf('.')).toLowerCase()
      return imgExts.includes(ext)
    }

    // 新增：处理上传点击
    const handleUploadClick = () => {
      uploadRef.value.$refs.input.click()
    }

    // 新增文件删除方法，删除实际文件不变，只会将文件状态修改为失效
    const handleDeleteFile = async (fileId) => {
      try {
        await assetService.deleteStoreDocument({
          fileId: fileId,
          storeEntCode: storeEntCode,
          documentType: state.currentDoc.type
        })
        ElMessage.success('文件删除成功')
        // 重新获取当前类型文件列表
        const response = await assetService.getStoreDocuments({
          storeEntCode: storeEntCode
        })
        state.documentFiles = response.data || {}
        state.currentDoc.files = state.documentFiles[state.currentDoc.type] || []
      } catch (error) {
        ElMessage.error('文件删除失败：' + (error.message || ''))
      }
    }

    // 新增文件下载方法
    const handleDownloadFile = (url, fileName) => {
      // 创建隐藏的下载链接
      const link = document.createElement('a')
      link.href = url
      link.download = fileName || '文件下载'
      link.style.display = 'none'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }

    // 新增：提交上传
    const submitUpload = () => {
      uploadRef.value.submit()
    }

    // 修改上传成功处理
    const handleUploadSuccess = async (response) => {
      if (response.msg) {
        ElMessage.success('文件上传成功')
        // 重新获取文件列表
        const docResponse = await assetService.getStoreDocuments({
          storeEntCode: storeEntCode
        })
        state.documentFiles = docResponse.data || {}
        state.currentDoc.files = state.documentFiles[state.currentDoc.type] || []
        fileList.value = []
      } else {
        ElMessage.error('文件上传失败：' + (response.message || ''))
      }
    }

    // 新增：上传失败处理
    const handleUploadError = (error) => {
      ElMessage.error('文件上传失败：' + (error.message || ''))
    }

    // 新增：上传请求头，根据实际情况添加认证信息
    const uploadHeaders = computed(() => {
      return {
        'Authorization': 'Bearer ' + store.state.token // 假设token存储在store中
      }
    })

    // 1. 定义支持的文件类型及对应的MIME类型（用于验证）
    const SUPPORTED_FILE_TYPES = {
      'doc': 'application/msword',
      'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'xls': 'application/vnd.ms-excel',
      'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'pdf': 'application/pdf',
      'jpg': 'image/jpeg',
      'jpeg': 'image/jpeg',
      'png': 'image/png',
      'txt': 'text/plain'
    };

    // 2. 上传前验证文件类型和大小
    const beforeUpload = (file) => {
      // 获取文件后缀（如"docx"）
      const ext = file.name.split('.').pop().toLowerCase();
      // 验证文件类型
      if (!Object.keys(SUPPORTED_FILE_TYPES).includes(ext)) {
        ElMessage.error(`不支持的文件类型：.${ext}，请上传Word、Excel、PDF等格式`);
        return false;
      }
      // 验证文件大小（10MB）
      const maxSize = 100 * 1024 * 1024; // 10MB
      if (file.size > maxSize) {
        ElMessage.error(`文件过大：${file.name}，请上传不超过10MB的文件`);
        return false;
      }
      return true;
    };

    // 3. 获取文件后缀（用于显示）
    const getFileExtension = (fileName) => {
      if (!fileName) return '未知类型';
      const ext = fileName.split('.').pop().toUpperCase();
      return ext || '未知类型';
    };

    // 4. 根据文件类型返回图标类名（需引入字体图标库，如FontAwesome）
    const getFileIcon = (fileName) => {
      if (!fileName) return 'icon-file';
      const ext = fileName.split('.').pop().toLowerCase();
      switch (ext) {
        case 'doc':
        case 'docx':
          return 'icon-file-word'; // Word图标
        case 'xls':
        case 'xlsx':
          return 'icon-file-excel'; // Excel图标
        case 'pdf':
          return 'icon-file-pdf'; // PDF图标
        case 'jpg':
        case 'jpeg':
        case 'png':
          return 'icon-file-image'; // 图片图标
        case 'txt':
          return 'icon-file-txt'; // 文本图标
        default:
          return 'icon-file'; // 通用文件图标
      }
    };


    const uniqueProfitAgreements = computed(() => {
      const agreements = state.profitCandidates || [];
      const uniqueMap = {};
      agreements.forEach(a => {
        if (!uniqueMap[a.agreementNo]) {
          uniqueMap[a.agreementNo] = { agreementNo: a.agreementNo };
        }
      });
      return Object.values(uniqueMap);
    });

    // 营收分区为懒加载，切过去时容器才具备尺寸，需要重新取数并渲染图表
    const onTabChange = (name) => {
      if (name === 'revenue') {
        nextTick(() => getIncomeData(storeEntCode))
      }
    }

    return {
      ...toRefs(state),
      activeTab,
      onTabChange,
      incomeChart,
      fundFormRef,
      profitFormRef,
      formatDate,
      formatCurrency,
      formatJointType,
      formatStatus,
      getStatusTagType,
      formatCapital,
      handleDateRangeChange,
      handleViewReceipt,
      hasPermission,
      handleCreateAgreement,
      handleCreateFundInfo,
      handleCreateProfitDistribution,
      submitCreateAgreement,
      submitCreateFund,
      submitCreateProfit,
      onProfitAgreementChange,
      onProfitTenantChange,
      uploadRef,
      fileList,
      uploadHeaders,
      handleViewDocument,
      handleCloseDocDialog,
      isImage,
      handleUploadClick,
      submitUpload,
      handleUploadSuccess,
      handleUploadError,
      handleDownloadFile,
      handleDeleteFile  ,
      beforeUpload,
      getFileExtension,
      getFileIcon,
      uniqueProfitAgreements
    }
  }
}
</script>

<style scoped>
.store-detail-page {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100vh;
  width: 100% !important;
}


.detail-card {
  background-color: #fff;
  border-radius: 4px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 20px;
  border-bottom: 1px solid #eee;
}
.card-header .actions { display: flex; gap: 8px; }

.card-header h2 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

/* 两列布局样式 */
.two-col-layout {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px 20px;
  padding: 10px 0;
  width: 100%;
}

.info-item {
  margin-bottom: 0;
  line-height: 2;
  display: flex;
  flex-wrap: wrap;
}

.label {
  display: inline-block;
  width: 140px;
  color: #666;
  font-weight: 500;
  flex-shrink: 0;
}

.value {
  color: #333;
  flex-grow: 1;
  min-width: 0;
  word-break: break-all;
}

.business-info-collapse {
  margin-top: 20px;
  border-top: 1px dashed #eee;
  padding-top: 15px;
}

.income-chart-container {
  width: 100%;
  height: 400px;
}

.income-chart {
  width: 100%;
  height: 100%;
}

/* 表格容器样式 - 支持横向滚动 */
.table-container {
  overflow-x: auto;
}

/* 表格列自适应 */
.el-table {
  table-layout: auto !important;
}

.el-table th {
  white-space: nowrap;
  padding: 12px 8px;
}

.el-table td {
  white-space: nowrap;
  padding: 12px 8px;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .two-col-layout {
    grid-template-columns: 1fr;
  }

  .income-chart-container {
    height: 300px;
  }
}

/* 新增：文件上传区域样式 */
.document-upload-area {
  padding: 20px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.document-content {
  min-height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px dashed #ccc;
  border-radius: 4px;
  padding: 20px;
}

.image-preview {
  width: 100%;
  text-align: center;
}

.preview-img {
  max-width: 100%;
  max-height: 500px;
  border-radius: 4px;
  margin-top: 10px;
}

.no-document {
  color: #999;
  font-size: 16px;
}

.file-link {
  margin-top: 10px;
  font-size: 16px;
}

.upload-area {
  text-align: center;
}

/* 文件图标样式（需配合字体图标使用） */
.file-item {
  display: flex;
  align-items: center;
  gap: 8px;
}
.file-icon {
  font-size: 18px;
}
/* 不同类型文件图标颜色 */
.icon-file-word { color: #2b579a; }    /* Word蓝色 */
.icon-file-excel { color: #217346; }   /* Excel绿色 */
.icon-file-pdf { color: #b7472a; }     /* PDF红色 */
.icon-file-image { color: #f4b400; }   /* 图片黄色 */
.icon-file-txt { color: #5f6368; }     /* 文本灰色 */
.icon-file { color: #888; }            /* 通用文件灰色 */

</style>
